if (!window.DeskpadProductData) {
  window.DeskpadProductData = {};
}
if (!window.DeskpadTranslations) {
  window.DeskpadTranslations = {};
}

export default window.DeskpadTranslations;